import { Card, CardContent } from '@/components/ui/card'
import { EmotionBarChart } from '@/components/ui/EmotionBarChart'
import { cn } from '@/lib/utils'
import { Alert, AlertTitle } from './alert'
import EmotionScatterChart from './EmotionScatterChart'
import { AnalysisExplanation } from './AnalysisExplanation'
import type { ResponseType } from '@/api/avpulse-api'

interface ImageAnalysisResultsProps {
  predictionUrl?: string
  valence?: number
  arousal?: number
  size?: 'small' | 'medium'
  showExplanation?: boolean
  showChart?: boolean
  explanation?: string
  explanationLoading?: boolean
  showClampedText?: boolean
  conversationId?: string
  responseType?: ResponseType
  runId?: string
}

export const ImageAnalysisResults: React.FC<ImageAnalysisResultsProps> = ({
  predictionUrl,
  valence,
  arousal,
  size = 'medium',
  showExplanation = true,
  showChart = true,
  explanation,
  explanationLoading,
  conversationId,
  responseType,
  runId,
}) => {
  if (!predictionUrl) return null

  return (
    <div className="grid grid-cols-1 gap-4">
      <Card>
        <CardContent className="space-y-12">
          {/* Image Display */}
          <div>
            <img
              src={predictionUrl}
              className="w-full rounded-lg"
              alt="Analysis result"
            />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          {/* Emotion Chart under the image */}
          {showChart && valence && arousal ? (
            <div>
              {size === 'small' ? (
                <EmotionBarChart
                  valence={valence}
                  arousal={arousal}
                  size={size}
                />
              ) : (
                <>
                  <header className="mb-4">Emotion Analysis</header>
                  <EmotionScatterChart
                    valence={valence}
                    arousal={arousal}
                    size={size}
                  />
                </>
              )}
            </div>
          ) : (
            <Alert>
              <AlertTitle>No valence or arousal data available</AlertTitle>
            </Alert>
          )}
        </CardContent>
      </Card>
      {showExplanation && (
        <AnalysisExplanation
          explanation={explanation || ''}
          explanationLoading={explanationLoading || false}
          conversationId={conversationId}
          responseType={responseType}
          runId={runId}
        />
      )}
    </div>
  )
}
